/**
 * Created by chenrozenes on 24/09/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import CleanSelect from './cleanSelect';

/**
 * CleanSelect wrap that gets intlEnum and displays it
 */
@autobind
class IntlSelect extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired, // eslint-disable-line react/no-unused-prop-types
  };

  onChange({ value }) {
    this.props.onChange(value);
  }

  render() {
    return (
      <CleanSelect {...this.props} onChange={this.onChange} />
    );
  }
}

export default compose(
  injectIntl,
  connect((state, props) => ({
    options: props.intlEnum.toSelectOptions(props.intl)
  }))
)(IntlSelect);
